import React from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import Pages from './Pages';

// noinspection JSCheckFunctionSignatures
const router = createBrowserRouter(Pages);
export default function Router() {
  return (
      <RouterProvider router={router} />
  );
}
